<template>
  <div>
    <v-list-item
      v-if="!commentDisplayed"
      class="checklist-item-comment-button-container"
      density="compact"
    >
      <template #default>
        <v-row no-gutters>
          <v-col cols="auto">
            <stb-icon-tooltip>
              <template #activator="{ props }">
                <div v-bind="props">
                  <cs-button
                    :id="commentBtnId"
                    class="checklist-item-comment-add-button"
                    :disabled="commentDisabled"
                    left-icon="mdi-chat"
                    label="Comment"
                    @click="commentDisplayed = true"
                  ></cs-button>
                </div>
              </template>
              <span>Add Comment</span>
            </stb-icon-tooltip>
          </v-col>
          <v-col>&nbsp;</v-col>
        </v-row>
      </template>
    </v-list-item>
    <v-list-item
      v-if="commentDisplayed"
      class="checklist-item-comment-content-container"
      density="compact"
    >
      <template #default>
        <v-textarea
          :id="`checklist-item-comment--${checklistItem.id}`"
          v-model="comment"
          class="checklist-item-comment"
          variant="outlined"
          color="primary"
          rows="2"
          auto-grow
          :disabled="commentDisabled"
          hide-details
          density="compact"
          @change="commentValueChanged()"
        >
        </v-textarea>
      </template>
    </v-list-item>
  </div>
</template>

<script>
import StbIconTooltip from './StbIconTooltip';

export default {
  name: 'ChecklistItemComment',

  components: {
    StbIconTooltip
  },

  props: {
    checklistItem: {
      type: Object,
      required: true
    },
    commentDisabled: Boolean,
    commentBtnId: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    comment: '',
    commentDisplayed: false
  }),
  watch: {
    checklistItem() {
      this.loadData();
    }
  },
  created() {
    this.loadData();
    this.$app.eventBus.$on('saveCompleteChecklist', this.loadData);
  },
  beforeUnmount() {
    this.$app.eventBus.$off('saveCompleteChecklist');
  },
  methods: {
    commentValueChanged() {
      // eslint-disable-next-line vue/no-mutating-props
      this.checklistItem.comment = this.comment.trim();
    },
    loadData() {
      if (undefined === this.checklistItem.comment) {
        this.comment = '';
      } else {
        this.comment = this.checklistItem.comment.trim();
      }

      if (this.comment) {
        this.commentDisplayed = true;
      } else {
        this.commentDisplayed = false;
      }
    }
  }
};
</script>
<style scoped>
.checklist-item-comment {
  padding-left: 8px;
}

.checklist-item-comment.theme--light.v-text-field--outline > .v-input__control > .v-input__slot {
  border: 2px solid rgba(0, 0, 0, 0.12) !important;
}

.checklist-item-comment.v-textarea.v-text-field--enclosed textarea {
  margin-top: unset;
}

.checklist-item-comment-button-container {
  padding-left: 48px;
}
</style>
